import React, { useEffect } from 'react'
import { FormControl, InputLabel, Select, MenuItem  } from '@mui/material'

function SelectBox({cityList, setCity, selectedCity}) {

    useEffect(()=> {
        if (cityList) {
            if (cityList.cityList.length === 1) {
                setCity(cityList.cityList[0])
            }
        }
    }, [cityList])

    const handleChange = (e) => {
        setCity(e.target.value)
    }

    return (
        <FormControl id="widget-selectBox" variant="standard" style={{maxWidth: '600px', width: '80%'}}>
            <InputLabel>Region</InputLabel>
            <Select value={selectedCity} onChange={handleChange}>
                {cityList && cityList.cityList.map((city, i)=>{
                    let cityName = city
                    if (city === "Montréal Datafeed") {
                        cityName = "Montréal"
                    }
                    return (
                        <MenuItem key={i} value={city}>{cityName}</MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}
    

export default SelectBox
